export const getCookie = (name: string): string | null => {
  if (typeof document === 'undefined') return null;
  for (const raw of document.cookie.split(';')) {
    const [key, ...rest] = raw.trim().split('=');
    if (key === name) return decodeURIComponent(rest.join('='));
  }
  return null;
};
